import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, map, of, switchMap, takeUntil, tap, timer} from 'rxjs';
import {EmailversandService, ProblemDTO} from '../../openapi/fakturierung-openapi';
import {SendenDialogActions} from '../actions/senden-dialog.actions';
import {mappedHttpErrorResponseOperator} from '@adnova/jf-ng-components';
import {NGXLogger} from 'ngx-logger';


export const ZUSTELLBARKEIT_DEBOUNCE_MS = 400;

/**
 * Effects fuer den Senden-Dialog: Laden der Versand-Vorschau (Betreff + Body)
 * und Pruefung, ob der letzte Versand an den Empfaenger unzustellbar war.
 */
@Injectable()
export class SendenDialogEffects {

  constructor(
    private readonly actions$: Actions,
    private readonly emailversandService: EmailversandService,
    private readonly _logger: NGXLogger,
  ) {
  }

  readonly loadVorschau$ = createEffect(() => this.actions$.pipe(
    ofType(SendenDialogActions.loadVorschau),
    switchMap(({betriebId, belegId}) =>
      this.emailversandService.readVersandVorschau(betriebId, belegId).pipe(
        map(response => SendenDialogActions.loadVorschauSuccess({
          betreff: response.betreff,
          body: response.body,
        })),
        catchError(error => of(error).pipe(
          mappedHttpErrorResponseOperator<ProblemDTO>(error),
          tap(mapped => this._logger.error('load vorschau failed.', 'status:', mapped.status)),
          map(mapped => SendenDialogActions.loadVorschauFailure({error: mapped})),
        )),
      ),
    ),
  ));

  readonly pruefeZustellbarkeit$ = createEffect(() => this.actions$.pipe(
    ofType(SendenDialogActions.pruefeZustellbarkeit),
    switchMap(({betriebId, empfaenger}) => timer(ZUSTELLBARKEIT_DEBOUNCE_MS).pipe(
      switchMap(() => this.emailversandService.pruefeZustellbarkeit(betriebId, {empfaenger})),
      map(response => SendenDialogActions.pruefeZustellbarkeitSuccess({
        zuletztUnzustellbar: response.zuletztUnzustellbar,
      })),
      catchError(error => of(error).pipe(
        mappedHttpErrorResponseOperator<ProblemDTO>(error),
        tap(mapped => this._logger.warn('pruefe zustellbarkeit failed.', 'status:', mapped.status)),
        map(() => SendenDialogActions.pruefeZustellbarkeitFailure()),
      )),
      takeUntil(this.actions$.pipe(ofType(
        SendenDialogActions.resetZustellbarkeit,
        SendenDialogActions.close,
      ))),
    )),
  ));
}
